// src/components/Auth/PrivateRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { ROUTES, isAdmin } from '../../App';  // Import these

const PrivateRoute = ({ children }) => {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!user) {
        localStorage.setItem('redirectUrl', location.pathname);
        return <Navigate to="/auth/login" />;
    }

    // Check if current route is admin-only
    const currentRoute = ROUTES.protected.find(route => {
        // Handle dynamic routes (like /websites/:id)
        if (route.path.includes(':')) {
            const routePattern = new RegExp(
                '^' + route.path.replace(/:[\w-]+/g, '[\\w-]+') + '$'
            );
            return routePattern.test(location.pathname);
        }
        return route.path === location.pathname;
    });

    // If route is admin-only and user is not admin, redirect to dashboard
    if (currentRoute?.adminOnly && !isAdmin(user)) {
        console.log('Non-admin user attempted to access admin route:', location.pathname);
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default PrivateRoute;